import { useCallback, useEffect, useMemo, useState } from 'react';

import { getCurrentViewportType } from '../../utils/viewport';
import { ViewportType } from '../../utils/viewport/getViewportType';
import { observeViewportResize } from '../../utils/viewport/observeViewportResize';

/**
 * Viewport type utility hook. Checks and updates viewport type in an optimized way.
 */
function useViewportType() {
  const [viewportType, setViewportType] = useState(() =>
    getCurrentViewportType()
  );

  const updateViewportType = useCallback(() => {
    const currentViewportType = getCurrentViewportType();

    if (currentViewportType !== viewportType) {
      setViewportType(currentViewportType);
    }
  }, [viewportType, setViewportType]);

  const viewportTypeFlags = useMemo(() => {
    return {
      isMobile: viewportType === ViewportType.MOBILE,
      isTablet: viewportType === ViewportType.TABLET,
      isDesktop: viewportType === ViewportType.DESKTOP,
    };
  }, [viewportType]);

  useEffect(() => {
    const { stopObserving } = observeViewportResize(updateViewportType);

    return () => stopObserving();
  }, [updateViewportType]);

  return { viewportType, ...viewportTypeFlags };
}

export { useViewportType };
